<template>
  <div class="tag">
    <div class="left"
         @click="scrollTags('left')"
         v-if="isShowControl">
      <i class="el-icon-arrow-left"></i>
    </div>
    <div class="content-wrap"> 
      <div class="tag-item"
           v-for="(v, k) in menu"
           :key="k"
           @click="$router.push({ name: v.name })"
           :class="{'tag-item-active': activeMenu.name === v.name ? true : false}">
        <span class="active-flag"
              v-if="activeMenu.name === v.name"></span>
        <span class="tag-title">{{v.meta.title}}</span>
        <span class="close-tag"
              v-if="menu.length > 1"
              @click.stop="close(v, k)">
          <i class="el-icon-close" />
        </span>
      </div>
    </div>
    <div class="right"
         @click="scrollTags('right')"
         v-if="isShowControl">
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "tag",
  data () {
    return {
      activeMenu: {},
      isShowControl: false,
      menu: []
    }
  },
  watch: {
    '$route' (newVal, oldVal) {
      if (newVal.meta.menu) {
        this.computedTag()
        this.addRoute(newVal).then(() => {
          this.$nextTick(() => {
            this.goActiveTag()
          })
        })
      }
    }
  },
  mounted () {
    this.activeMenu = this.$route;
    if (this.$route.meta.menu) {
      this.menu.push(this.activeMenu)
      setTimeout(() => {
        this.computedTag()
      }, 1000)
    }
  },
  methods: {
    // 更新tag
    computedTag () {
      this.$nextTick(() => {
        const wrap = document.querySelector('.content-wrap')
        let tagItem = document.querySelectorAll('.tag-item') || []
        tagItem = Array.from(tagItem) || []
        const wrapWidth = wrap ? wrap.getBoundingClientRect().width : 0
        const tagItemWidth = tagItem.map(v => v.getBoundingClientRect().width + 10).reduce((pre, cur) => cur + pre, 0)
        if (tagItemWidth >= wrapWidth - 50) {
          this.isShowControl = true
        }
      })
    },
    // 滚动
    scrollTags (direction) {
      this.$nextTick(() => {
        this.scrollActionAnimate(200, direction)
      })
    },
    // 滚动条动画
    scrollActionAnimate (distance, direction) {
      let hasScroll = 0
      let timer = null
      clearInterval(timer)
      timer = setInterval(() => {
        const wrap = document.querySelector('.content-wrap')
        hasScroll += 2
        if (direction === 'left') {
          wrap.scrollLeft = wrap.scrollLeft - 2
        } else {
          wrap.scrollLeft = wrap.scrollLeft + 2
        }
        if (hasScroll >= distance) {
          clearInterval(timer)
        }
      }, .5)
    },
    // 路由添加
    addRoute (route) {
      this.activeMenu = route
      const isNewRoute = this.menu.every(v => v.name !== route.name)
      return new Promise((resolve, reject) => {
        if (isNewRoute) {
          this.menu.push(route)
          resolve()
        } else {
          resolve()
        }
      })
    },
    // 定位当前激活的tag
    goActiveTag () {
      // 获取当前激活的tag的index
      let index = -1
      this.menu.forEach((v, k) => {
        if (v.name === this.activeMenu.name) {
          index = k
        }
      })
      // 获取当前tag之前的所有tag长度并且滚动
      let totalWidth = 0
      let tags = document.querySelectorAll('.tag-item') || []
      const wrap = document.querySelector('.content-wrap')
      const wrapWidth = wrap ? wrap.getBoundingClientRect().width : 0
      if (this.isShowControl) {
        tags = Array.from(tags)
        tags.forEach((v, k) => {
          if (k <= index) {
            let tagWidth = v.getBoundingClientRect().width
            totalWidth += tagWidth + 10
          }
        })
        const scrollWidth = totalWidth - wrapWidth + wrapWidth / 2
        wrap.scrollLeft = scrollWidth
      }
    },
    // 关闭
    close (v, k) {
      this.menu.splice(k, 1)
      if (v.name === this.activeMenu.name) {
        this.$router.push({ name: this.menu[this.menu.length - 1].name })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tag {
  width: 98%;
  height: 40px;
  background-color: #fff;
  display: flex;
  align-items: center;
  margin-top: 5px;
  .content-wrap {
    width: 0px;
    padding: 0 5px;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    transition: all 1s;
    &::-webkit-scrollbar {
      display: none;
    }
    .tag-item-active {
      color: white !important;
      background-color: #0091F2 !important;
      border: none !important;
    }
    .tag-item {
      display: flex;
      position: relative;
      cursor: pointer;
      height: 26px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-right: 10px;
      box-sizing: border-box;
      flex-shrink: 0;
      transition: all 0.1s;
      overflow: hidden;
      align-items: center;
      &:hover {
        box-shadow: 0 0 3px 1px #eee;
      }
      .active-flag {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #fff;
      }
      .tag-title {
        margin-left: 10px;
      }
      .close-tag {
        font-size: 14px !important;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        transition: all 0.1s;
        &:hover {
          background: #eee;
          color: #111;
        }
      }
    }
  }
  .left,
  .right {
    font-size: 20px;
    overflow: hidden;
    width: 26px;
    height: 26px;
    line-height: 26px;
    color: #333;
    cursor: pointer;
    text-align: center;
    box-shadow: -4px 0 3px -1px #ccc;
    z-index: 2;
  }
  .left {
    box-shadow: 4px 0 3px -1px #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// app-tags.vue?4e501b8e